// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__1eTEK"};